import cx from 'classnames';
import styles from '../components/Icons/Icons.module.scss';
import RemoveDuplicateIcon from './raw/remove-duplicate.svg?react';
import type { IconProps } from './types';

const RemoveDuplicate = ({
  className,
  iconClass = true,
  label,
  style,
  viewBox,
}: IconProps) => (
  <RemoveDuplicateIcon
    title={label}
    aria-labelledby={label}
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    viewBox={viewBox || '-2 -2 22 22'}
    className={cx({
      [styles.svgIcon]: iconClass,
      ...(className
        ? {
            [styles[className]]: className && styles[className],
            [className]: className && !styles[className],
          }
        : {}),
    })}
    style={style}
  />
);

export default RemoveDuplicate;
